import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';

import {ProductsCategory} from './products-category';

@Injectable()
export class ProductsCategoryService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private api_url_get_categories = './api/server.php?cmd=GET_CATEGORIES_BIS';
    private api_url_get_categories_modif = './api/server.php?cmd=GET_CATEGORIES_MODIF_BIS';
    private api_url_get_categories_tree = './api/server.php?cmd=GET_CATEGORIES_TREE_BIS';
    private api_url_insert_category = './api/server.php?cmd=INSERT_CATEGORY_BIS';
    private api_url_modify_category = './api/server.php?cmd=MODIFY_CATEGORY_BIS';
    private api_url_delete_category = './api/server.php?cmd=DELETE_CATEGORY_BIS';

    private category_name: string;
    private category_parent: number;
    private category_id: number;
    private category_prefix: string;

    constructor(private http: Http) {}

    GetCategoriesList(): Promise<ProductsCategory[]> {
        return this.http.get(this.api_url_get_categories)
            .toPromise()
            .then(response => response.json() as ProductsCategory[])
            .catch(this.handleError);
    }

    GetCategoriesListModif(reference: any): Promise<ProductsCategory[]> {
        return this.http.get(this.api_url_get_categories_modif
            + '&reference=' + reference
        )
            .toPromise()
            .then(response => response.json() as ProductsCategory[])
            .catch(this.handleError);
    }

    GetCategoriesListTree(): Promise<ProductsCategory[]> {
        return this.http.get(this.api_url_get_categories_tree)
            .toPromise()
            .then(response => response.json() as ProductsCategory[])
            .catch(this.handleError);
    }

    InsertCategory(category: ProductsCategory): Promise<ProductsCategory[]> {
        this.category_name = category.name;

        return this.http.get(this.api_url_insert_category
            + '&category_name=' + this.category_name
            + '&category_reference=' + category.reference
            + '&category_reference_parent=' + category.reference_parent
        )
            .toPromise()
            .then(response => response.json() as ProductsCategory[])
            .catch(this.handleError);

    }

    ConfirmModification(category: ProductsCategory, reference: any): Promise<ProductsCategory[]> {
        this.category_id = category.id_products_category;
        this.category_name = category.name;

        return this.http.get(this.api_url_modify_category
            + '&id_category=' + this.category_id
            + '&category_name=' + this.category_name
            + '&category_reference=' + category.reference
            + '&reference=' + reference
            + '&category_reference_parent=' + category.reference_parent
        )
            .toPromise()
            .then(response => response.json() as ProductsCategory[])
            .catch(this.handleError);
    }

    DeleteCategory(category: ProductsCategory): Promise<ProductsCategory[]> {
        this.category_id = category.id_products_category;
        return this.http.get(this.api_url_delete_category
            + '&id_category=' + this.category_id
        )
            .toPromise()
            .then(response => response.json() as ProductsCategory[])
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// ./src/app/products-category.service.ts